module.exports = __webpack_public_path__ + "img/SER-A-1-II.973b0c67.png";